import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export function CountdownBanner() {
    const { t } = useTranslation();
    const [timeLeft, setTimeLeft] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    });

    useEffect(() => {
        // Target date: August 29, 2026, 00:00:00 (Local Time)
        const targetDate = new Date(2026, 7, 29, 0, 0, 0).getTime();

        const updateCountdown = () => {
            const now = new Date().getTime();
            const difference = targetDate - now;

            if (difference > 0) {
                setTimeLeft({
                    days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                    hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
                    minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
                    seconds: Math.floor((difference % (1000 * 60)) / 1000)
                });
            } else {
                // Countdown finished
                setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
            }
        };

        // Initial call
        updateCountdown();

        // Set interval to update every second
        const intervalId = setInterval(updateCountdown, 1000);

        // Cleanup on unmount
        return () => clearInterval(intervalId);
    }, []);

    return (
        <div className="w-full bg-secondary py-6 md:py-8 flex justify-center items-center overflow-x-hidden">
            <div className="text-countdown-text font-sans uppercase tracking-widest sm:tracking-[0.4em] md:tracking-[0.6em] text-[12px] sm:text-base md:text-base font-light text-center px-4 whitespace-nowrap">
                {timeLeft.days} <span className="mr-1.5 sm:mr-4 md:mr-6">{t('timer.days')}</span>
                {timeLeft.hours} <span className="mr-1.5 sm:mr-4 md:mr-6">{t('timer.hours')}</span>
                {timeLeft.minutes} <span className="mr-1.5 sm:mr-4 md:mr-6">{t('timer.minutes')}</span>
                {timeLeft.seconds} <span>{t('timer.seconds')}</span>
            </div>
        </div>
    );
}
